import { FC, useEffect } from 'react';
import { styled } from '@mui/material/styles';

import { useAtomValue } from 'jotai';
import { Card } from '../../../../../components/Card/Card';
import { ColumnDataPtList } from '../ColumnsMenu/ColumnDataPtList';
import { SelectedColumns } from '../SelectedColumns/SelectedColumns';
import { useColumnSelector } from '../../../providers/ColumnSelectorProvider';
import { pfGridApiAtom } from '../PfState';
import { ColumnsSettingsActionButtons } from './ColumnsSettingsActionButtons';
import { ColumnsSettingsHeader } from './ColumnsSettingsHeader';
import { getCurrentVisibleColumns } from './getCurrentVisibleColumns';

const Container = styled('div')`
  position: absolute;
  left: 40px;
  right: 40px;
  margin-top: 4px;
  z-index: 10;
  background-color: ${({ theme }) => theme.colors.primary[0]};
  box-shadow:
    0px -4px 40px rgba(255, 255, 255, 0.1),
    0px 4px 24px rgba(16, 37, 62, 0.06),
    0px 24px 48px rgba(75, 82, 93, 0.04);
  border-radius: 4px;
  padding: 24px;
`;

const ColumnsSectionWrapper = styled('div')`
  display: grid;
  grid-template-columns: 3fr 1fr;
  column-gap: 16px;
  height: 550px;
`;

const ColMenuContainer = styled('div')`
  background-color: white;
  width: 100%;
  max-width: 100%;
  height: 500px;
  overflow-y: scroll;
`;

export const ColumnsSettingsContent: FC = () => {
  const { setActiveOrder } = useColumnSelector();
  const gridApi = useAtomValue(pfGridApiAtom);

  // initially set active order to the currently visible columns
  // (takes care of the cancel button  - if setActiveOrder is called before canceling,
  // this will nullify the effects)
  useEffect(() => {
    if (!gridApi) {
      return;
    }
    setActiveOrder(getCurrentVisibleColumns(gridApi));
  }, [gridApi, setActiveOrder]);

  return (
    <Container>
      <ColumnsSettingsHeader />
      <ColumnsSectionWrapper>
        <Card hasBorder header='Available Columns'>
          <ColMenuContainer>
            <ColumnDataPtList />
          </ColMenuContainer>
        </Card>

        <Card hasBorder header='Columns Selected'>
          <SelectedColumns />
        </Card>
      </ColumnsSectionWrapper>
      <ColumnsSettingsActionButtons />
    </Container>
  );
};
